import Container from "../../components/menu/Container";
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import findPropostaCredito from "../../service/findPropostaCredito";
import { SortOrder } from 'primereact/api';
import { Button } from 'primereact/button';
import { Card } from "primereact/card";
import { Badge } from "primereact/badge";
import { Nullable } from "primereact/ts-helpers";


export default function HistoricoPage() {
  const { t } = useTranslation();
  const [propostas, setPropostas] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const [counts, setCounts] = useState([]);
  const [status, setStatus] = useState<Nullable<String | null>>(null);

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    status: status,
    sortField: "data",
    sortOrder: SortOrder.DESC,
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: event.first / event.rows + 1,
      status: status,
      sortField: event.sortField,
      sortOrder: event.sortOrder,
    });
  };

  const onSort = (event: any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      status: status,
      sortField: event.sortField,
      sortOrder: event.sortOrder,
    });
  };

  

  

  const loadLazyData = () => {
    findPropostaCredito(lazyState)
      .then((data) => {
        setTotalRecords(data.total);
        setPropostas(data.propostas);
        setCounts(data.status)
      })
      .catch(() => {
        setTotalRecords(0);
        setPropostas(undefined);
        setCounts([])
      });
  };
  const cols = [
    { field: 'data', header: 'Data' },
    { field: 'dataRequisicao', header: 'Dt. Solicitação' },
    { field: 'ip', header: 'IP' },
    { field: 'documento', header: 'Documento' },
    { field: 'usuario', header: 'Usuário' },
    { field: 'opcao', header: 'Opção' },
    { field: 'origem', header: 'Origem' },
    { field: 'cache', header: 'Cache' },
    { field: 'erro', header: 'Erro' }
];
  const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));
  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const lazy = {
          first: 0,
          rows: totalRecords,
          page: 1,
          sortField: "data",
          sortOrder: SortOrder.DESC,
        };
        findPropostaCredito(lazy).then((data) => {
          const doc: any = new jsPDF.default("portrait");
          doc.autoTable(exportColumns, data.consultas);
          doc.save("consultas.pdf");
        });
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const lazy = {
        first: 0,
        rows: totalRecords,
        page: 1,
        status: status,
        sortField: "data",
        sortOrder: SortOrder.DESC,
      };
      findPropostaCredito(lazy).then((data) => {
        const worksheet = xlsx.utils.json_to_sheet(data.consultas);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer, "consultas");
      });
    });
  };

  const headerCard = (item:any) => {return (
      <> 
       <div style={{display:"flex", justifyContent:"flex-end"}} className="flex-consulta">
          {status && status === item.status && (<Button icon="pi pi-times" className='button_remove_backgroung' onClick={(e) => {e.stopPropagation(); changeStatus(null)}} text style={{color:'rgb(24, 52, 98)'}}  aria-label="Cancel" />)}
       </div> </>
    )};

  const footerCard = (item:any) => {return (
    <> 
     <div style={{display:"flex-consulta", justifyContent:"flex-end"}} className="flex-consulta">
        
     </div> </>
  )};

  const saveAsExcelFile = (excelBuffer: any, fileName: string) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([excelBuffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };
  const header = (
    <div className="flex-consulta align-items-center justify-content-end gap-2">
      <Button
        type="button"
        icon="pi pi-file-excel"
        severity="success"
        rounded
        onClick={exportExcel}
        data-pr-tooltip="XLS"
      />
      <Button
        type="button"
        icon="pi pi-file-pdf"
        severity="warning"
        rounded
        onClick={exportPdf}
        data-pr-tooltip="PDF"
      />
    </div>
  );

  const changeStatus = (status:Nullable<any>) => {
      status = status ? status : null
      if(status instanceof Object){
        status = null
      }
      
        setStatus(status);
        setlazyState({
          first: lazyState.first,
          rows: lazyState.rows,
          page: (lazyState.first / lazyState.rows) + 1,
          status: status,
          sortField: 'data',
          sortOrder: SortOrder.DESC
        });
      
    }

const statusTemplate = (registro:any) => {
    
    const statusClass = registro.status === 'Reprovado' ? 'status-badge-erro' : (registro.status === 'Incluído' ? 'status-badge-incluido' : (registro.status === 'Aprovado' ? 'status-badge-registrado' : (registro.status === 'Operação Manual' ? 'status-badge-excluido' : (registro.status == 'Cancelado' ? 'status-badge-cancelado' : 'status-badge-total'))))
    return <>
    <Badge value={registro.status} className={statusClass + (registro.descricaoCancelamento ? ' custom-tooltip-btn custom-cursor' : '')}></Badge></>
  }

  const actionTemplate = (proposta: any) => {
      return (
        <>
         
          
              <Button
                icon="pi pi-window-maximize"
                onClick={() => {
                  window.open("/app/proposta/" + proposta.id, "_blank");
                }}
                style={{
                  background: "transparent",
                  color: "gray",
                  border: "none",
                }}
              />
        </>
      );
    };

   
  useEffect(() => {
    loadLazyData();
  }, [lazyState]);

  return (
    <Container>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray">
              <i className="pi pi-list-check" style={{ fontSize: "2.0rem" }}></i>{" "}
              {t("historicoPropostaCredito")}
            </h1>
          </div>
        </div>
      </div>
      <br></br>
              <div className="flex-consulta  flex-wrap gap-3">
                  {counts.map((item:any, index:number) => (
                     
                        <Card footer={footerCard(item)} style={{cursor:'pointer'}} className={(status && status !== item.status ? 'flex-1 disabled' : 'flex-1') + (status && status === item.status ? ' show-hide' : '') } header={headerCard(item)} key={index} onClick={() => changeStatus(item.status !== 'undefined' ? item.status : null)}>
                            <div className="flex-consulta  justify-content-between gap-5">
                                <div className="flex-consulta  flex-column gap-1">
                                    <span className="text-secondary text-sm">{statusTemplate({status:item.statusLabel})}</span>
                                    <span className="font-bold text-lg">{item.total}</span>
                                </div>
                                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: item.status === 'REPROVADO' ? 'var(--red-500)' : (item.status === 'INCLUIDO' ? 'var(--blue-500)' : (item.status === 'APROVADO' ? 'var(--green-500)' : (item.status === 'MANUAL' ? 'var(--orange-500)' : (item.status === 'CANCELADO' ? 'var(--yellow-500)' : 'var(--teal-500)')))), color: '#ffffff' }}>
                                    <i className={item.status === 'REPROVADO' ? 'pi pi-exclamation-triangle' : (item.status === 'MANUAL' ? 'pi pi-times' : (item.status === 'CANCELADO' ? 'pi pi-times-circle' : (item.status === 'INCLUIDO' ? 'pi pi-file-plus' : (item.status === 'APROVADO' ? 'pi pi-folder-plus' : 'pi pi-gauge'))) ) } />
                                </span>
                            </div>
                        </Card>
                      
                  ))}
              </div>
               <br></br>
      <div className="card">
        
        <DataTable value={propostas} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros" header={header}
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column field="data" sortable header={t('data')}  />
           <Column field="documento" sortable header={t('documento')}  />
           <Column field="usuario"  header={t('usuario')}  />
           <Column body={statusTemplate}  header={t('status')}  />
           <Column style={{width: '11%'}} body={actionTemplate} />
           
          
        </DataTable> 
      </div>
    </Container>
  );
}
